// extracted by mini-css-extract-plugin
export default {"box":"multiSelect-module__box__3t9Qo","box-checked":"multiSelect-module__box-checked__qx4AU"};